export default __webpack_public_path__ + "static/media/sun.e084c732.png";